<template>
  <div class="header_wrapper">
    <header>
      <nav class="row no-gutters">
        <div class="brand-nav col-2">
          <a :href="getPathUrl1()" class="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="134" height="56" fill="none">
              <path fill="#fff"
                d="M107.009 33.788c-1.08 0-2.399.535-3.173 1.04l-.219-.576a.387.387 0 0 0-.367-.25h-1.727a.392.392 0 0 0-.392.392v13.044c0 .214.178.392.392.392h2.262a.389.389 0 0 0 .392-.392v-3.214c.718.174 1.798.296 2.623.296 2.338 0 3.468-1.243 3.468-3.81v-3.112c0-3.147-1.772-3.81-3.259-3.81Zm.214 6.917c0 .774-.372 1.166-1.101 1.166-.652 0-1.436-.132-1.945-.254v-4.38c.453-.388 1.253-.805 1.945-.805.744 0 1.101.382 1.101 1.161v3.112ZM44.138 26.067h5.618c2.633 0 4.084-1.197 4.084-3.366v-1.376c0-1.242-.85-2.312-2.073-2.602 1.065-.464 1.564-1.172 1.564-2.221v-1.436c0-1.33-.418-3.092-4.018-3.092h-5.175a.392.392 0 0 0-.392.392v13.309c0 .214.173.392.392.392Zm2.78-11.53h1.972c.84 0 1.268.335 1.268.992v1.228c0 .234-.092.993-1.268.993h-1.971V14.53v.005Zm0 5.693h2.415c.5 0 1.33.153 1.33 1.187v.871c0 .86-.53 1.227-1.778 1.227h-1.971v-3.28l.005-.005Zm83.947 10.008c-1.319 0-2.414 1.024-2.414 2.44s1.095 2.44 2.414 2.44c1.319 0 2.414-1.029 2.414-2.44 0-1.41-1.095-2.44-2.414-2.44Zm0 4.483c-1.105 0-2.011-.856-2.011-2.043 0-1.187.906-2.052 2.011-2.052 1.106 0 2.002.855 2.002 2.052s-.891 2.043-2.002 2.043ZM13.319 0H4.457A4.458 4.458 0 0 0 0 4.457v47.086A4.458 4.458 0 0 0 4.457 56h8.862a.67.67 0 0 0 .667-.667v-5.618a.67.67 0 0 0-.667-.667H9.993a2.97 2.97 0 0 1-2.97-2.97V9.917a2.97 2.97 0 0 1 2.97-2.97h3.326a.67.67 0 0 0 .667-.667V.667A.67.67 0 0 0 13.319 0Zm89.406 26.067h2.262a.392.392 0 0 0 .392-.392v-5.893c.616-.489 1.446-.917 2.465-1.263a.395.395 0 0 0 .265-.372v-2.113a.403.403 0 0 0-.148-.311.392.392 0 0 0-.244-.082c-.031 0-.062 0-.097.01-.932.235-1.981.734-2.537 1.106l-.142-.683a.388.388 0 0 0-.382-.31h-1.829a.392.392 0 0 0-.392.392v9.524c0 .214.178.392.392.392l-.005-.005ZM27.025 0h-8.863a.67.67 0 0 0-.667.667v5.618c0 .367.3.667.667.667h3.326a2.97 2.97 0 0 1 2.97 2.97v7.39c0 .473-.112.922-.311 1.319l-3.968 8.002a2.96 2.96 0 0 0 0 2.745l3.968 8.001c.199.403.306.846.306 1.32V46.088a2.97 2.97 0 0 1-2.97 2.969h-3.326a.67.67 0 0 0-.667.667v5.618c0 .367.3.667.667.667h8.863a4.458 4.458 0 0 0 4.456-4.456V38.107c0-.743-.183-1.446-.51-2.067l-3.055-6.163a4.395 4.395 0 0 1-.408-1.864c0-.668.148-1.299.408-1.864l3.056-6.158c.326-.622.51-1.324.51-2.068V4.457A4.454 4.454 0 0 0 27.024 0Zm55.669 29.587h2.261a.396.396 0 0 0 .392-.393v-3.213c.718.178 1.798.295 2.623.295 2.338 0 3.469-1.243 3.469-3.81V19.36c0-3.147-1.773-3.81-3.26-3.81-1.08 0-2.399.54-3.173 1.04l-.22-.576a.387.387 0 0 0-.366-.25h-1.726a.392.392 0 0 0-.393.393V29.2c0 .213.174.392.393.392v-.005Zm2.653-10.59c.454-.386 1.253-.804 1.946-.804.738 0 1.1.382 1.1 1.166v3.107c0 .774-.372 1.167-1.1 1.167-.657 0-1.437-.133-1.946-.255v-4.38Zm-19.176 7.07h2.262a.396.396 0 0 0 .392-.392v-6.423c.662-.361 1.675-.743 2.22-.743.494 0 .744.25.744.743v6.423c0 .214.178.392.392.392h2.262a.392.392 0 0 0 .392-.392v-6.423c.667-.361 1.68-.743 2.22-.743.49 0 .739.25.739.743v6.423c0 .214.178.392.397.392h2.262a.396.396 0 0 0 .392-.392V18.85c0-2.22-.774-3.3-2.369-3.3-1.314 0-2.857.371-4.125.993-.372-.662-1.009-.993-1.885-.993-1.227 0-2.877.402-4.105.993l-.219-.54a.393.393 0 0 0-.361-.245h-1.605a.396.396 0 0 0-.392.393v9.524c0 .214.178.392.392.392h-.005Zm16.467 7.935h-2.262a.392.392 0 0 0-.392.392v6.423c-.667.362-1.676.739-2.226.739-.489 0-.738-.25-.738-.739v-6.422a.392.392 0 0 0-.392-.393h-2.262a.39.39 0 0 0-.392.392v6.825c0 2.221.774 3.3 2.373 3.3 1.223 0 2.873-.396 4.106-.992l.219.54a.388.388 0 0 0 .361.244h1.605a.39.39 0 0 0 .392-.392v-9.52a.396.396 0 0 0-.392-.392v-.005Zm33.192-.214c-2.934 0-4.421 1.386-4.421 4.126v2.41c0 2.82 1.508 4.19 4.615 4.19 1.146 0 2.546-.264 3.397-.493a.393.393 0 0 0 .29-.382v-1.625a.395.395 0 0 0-.392-.392c-.031 0-.061 0-.092.01-.942.224-2.139.382-2.908.382-1.426 0-1.859-.351-1.859-1.503v-.295h5.149a.389.389 0 0 0 .392-.392v-1.762c0-2.919-1.324-4.273-4.166-4.273h-.005Zm1.289 4.146h-2.664v-.443c0-.87.469-1.309 1.395-1.309.927 0 1.269.392 1.269 1.31v.442Zm-68.58-3.937H46.75v-2.083a.39.39 0 0 0-.392-.392h-2.262a.396.396 0 0 0-.392.392v2.083h-1.003a.39.39 0 0 0-.393.392v1.671a.39.39 0 0 0 .393.392h1.003v5.42c0 1.777 1.019 2.643 3.112 2.643.443 0 1.064-.087 1.67-.234a.392.392 0 0 0 .301-.383v-1.604c0-.117-.05-.23-.143-.305a.402.402 0 0 0-.25-.087c-.025 0-.05 0-.076.01a5.12 5.12 0 0 1-.932.107c-.631 0-.631-.428-.631-.57v-4.997h1.788a.39.39 0 0 0 .392-.392v-1.67a.392.392 0 0 0-.392-.393h-.006Zm78.002-.122c-.03 0-.061 0-.097.01-.932.235-1.981.734-2.536 1.105l-.148-.682a.386.386 0 0 0-.382-.31h-1.828a.392.392 0 0 0-.392.392v9.519c0 .219.173.392.392.392h2.261a.389.389 0 0 0 .392-.392v-5.893c.612-.49 1.442-.917 2.465-1.268a.395.395 0 0 0 .265-.372v-2.114a.403.403 0 0 0-.152-.31.381.381 0 0 0-.24-.082v.005Zm-29.24-.092c-1.314 0-2.857.372-4.126.993-.371-.662-1.008-.993-1.884-.993-1.222 0-2.873.398-4.105.993l-.214-.54a.393.393 0 0 0-.362-.244H85a.39.39 0 0 0-.391.392v9.52a.39.39 0 0 0 .392.392h2.261a.39.39 0 0 0 .392-.392V37.48c.668-.362 1.676-.739 2.221-.739.494 0 .744.25.744.739v6.423c0 .219.178.392.392.392h2.261a.39.39 0 0 0 .392-.392v-6.418c.662-.367 1.676-.743 2.221-.743.489 0 .739.25.739.738v6.423c0 .219.178.392.392.392h2.261a.392.392 0 0 0 .392-.392v-6.82c0-2.22-.774-3.3-2.368-3.3Zm-26.709 3.173c1.065-.463 1.569-1.166 1.569-2.22V33.3c0-1.325-.418-3.092-4.024-3.092h-5.17a.392.392 0 0 0-.392.392v13.304c0 .219.179.392.392.392h5.618c2.634 0 4.085-1.197 4.085-3.367v-1.375a2.677 2.677 0 0 0-2.073-2.603l-.005.005Zm-4.844-4.191h1.966c.84 0 1.269.336 1.269.993v1.227c0 .235-.092.993-1.269.993h-1.966V32.76v.005Zm3.744 7.746c0 .861-.53 1.228-1.778 1.228h-1.966v-3.28h2.415c.499 0 1.334.153 1.334 1.187v.865h-.005Zm31.277-18.534a.393.393 0 0 0 .393-.392v-1.762c0-2.919-1.325-4.273-4.167-4.273-2.842 0-4.426 1.39-4.426 4.125v2.414c0 2.822 1.508 4.192 4.615 4.192 1.146 0 2.546-.265 3.397-.494a.393.393 0 0 0 .29-.382V23.78a.388.388 0 0 0-.147-.305.4.4 0 0 0-.337-.077c-.942.224-2.139.382-2.903.382-1.43 0-1.864-.351-1.864-1.502v-.296h5.155l-.006-.005Zm-5.154-2.73c0-.87.469-1.314 1.4-1.314.933 0 1.269.392 1.269 1.314v.443h-2.669v-.443Zm36.325 12.958c0-.535-.346-.84-.907-.84h-1.12v2.561h.56v-.907h.331l.601.907h.627l-.652-.963c.346-.091.56-.361.56-.758Zm-.932.346h-.535v-.708h.535c.255 0 .397.158.397.362 0 .188-.148.346-.397.346Zm-76.811 1.232c-3.85 0-4.655 2.267-4.655 4.167v2.393c0 1.9.81 4.167 4.655 4.167s4.655-2.267 4.655-4.167V37.95c0-1.9-.804-4.167-4.655-4.167Zm1.61 6.642c0 1.258-.877 1.523-1.61 1.523-.733 0-1.61-.265-1.61-1.523v-2.562c0-1.258.877-1.523 1.61-1.523.733 0 1.61.265 1.61 1.523v2.562ZM64.2 25.67v-9.525a.396.396 0 0 0-.392-.392H61.54a.396.396 0 0 0-.392.392v6.423c-.662.362-1.675.739-2.22.739-.49 0-.744-.25-.744-.739v-6.423a.392.392 0 0 0-.392-.392H55.53a.392.392 0 0 0-.392.392v6.825c0 2.221.774 3.3 2.369 3.3 1.222 0 2.872-.396 4.105-.992l.219.535a.393.393 0 0 0 .361.244h1.61a.396.396 0 0 0 .392-.392l.005.005Z" />
            </svg> </a>
        </div>

        <div class="primary-nav col">
          <div class="primary-nav__top">
            <span v-for="top in topNavigation" v-bind:key="top.entity_id">
              <b-link v-if="!top.pdf" :to="`${getPathUrl()}/${top.slug}`">
                {{ top.page_title }}
              </b-link>
              <b-link v-else-if="top.pdf && top.pdf.file && top.pdf.file.url" :href="top.pdf.file.url" target="_blank">
                {{ top.page_title }}
              </b-link>
            </span>
            <a :href="getPdfGenerationUrl" target="_blank">
              <IconPrint />
            </a>
            <b-link href="#" class="lang-switcher" @click="changeLang">
              {{ $t('header.lang') }}
            </b-link>
          </div>
          <div class="primary-nav__bottom">
            <multi-level-menu />
            <AlgoliaSearch siteID="5" />
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
import MultiLevelMenu from '../menu/MultiLevelMenu.vue'
import headerMixing from '../../../mixins/header'
import AlgoliaSearch from '../../common/AlgoliaSearch.vue'
import IconPrint from '../../icons/IconPrint.vue'

export default {
  name: 'Header',
  mixins: [headerMixing],
  components: {
    AlgoliaSearch,
    MultiLevelMenu,
    IconPrint
  }
}
</script>

<style lang="scss" scoped>
.header_wrapper {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
}

header {
  position: relative;

  &:after {
    content: '';
    width: 100vw;
    height: 1px;
    background-color: $black;
    background-blend-mode: multiply;
    opacity: 0.2;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  nav {
    min-height: 100px;
  }
}

.brand-nav {
  background-color: $red;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 80%;
  }

  svg {
    fill: $white;
    max-height: 10rem;

    @media only screen and (min-width:1500px) {
      // padding: 2rem;
    }
  }
}

.primary-nav {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;

  a {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: inherit;
    text-align: center;
    padding: 10px;
    line-height: 1.1;

    transition: all 0.3s ease;
  }

  &__top {
    background-color: $red;
    height: 30px;
    border: solid 1px rgba(31, 27, 30, 0.15);
    display: flex;
    justify-content: flex-end;

    a {
      padding: 0 1.5rem;

      &:hover {
        color: $white;
      }

      &.lang-switcher {
        padding: 0 3.6rem 0 1.2rem;
        border-left: 1px solid rgba(31, 27, 30, 0.15);
      }
    }
  }

  &__bottom {
    background-color: $black;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: inherit;

    a {
      flex: 0 1 8.3333333333vw;
      color: $white;
      background-color: inherit;
      transition: all 0.3s ease;
      font-size: 1.3rem;

      &:hover,
      &.router-link-active {
        background-color: $menu-active;
      }
    }
  }
}

.store-nav {
  background-color: $black;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  label {
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 0;
    line-height: 1.1;
    font-size: 1.2rem;
  }

  a {
    display: flex;
    text-decoration: none;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.2rem;

    transition: all 0.3s ease;

    @include breakpoint('xl') {
      padding: 0 2.5rem;
    }

    >* {
      cursor: pointer;
    }
  }

  .cta-find-store {
    background-color: #d70e08;
    height: 30px;
    color: $white;

    svg path {
      fill: #f5b5b3;
    }

    &:hover {
      background-color: $red;
    }
  }

  .cta-my-store {
    background-color: $white;
    height: 70px;

    address {
      font-size: 0.9rem;
      margin-bottom: 0;
      line-height: 1.22;
      font-weight: 600;
    }

    .svg-store {
      transform: scale(1.2);
    }

    svg {

      fill: #BDBAC4;

      path {
        fill: #BDBAC4;
      }
    }
  }
}

.login-nav {
  background-color: $black;
  color: $white;

  display: flex;
  align-items: stretch;
  justify-content: center;
  align-content: center;

  a {
    color: $white;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: inherit;

    transition: all 0.3s ease;

    &:hover {
      background-color: $menu-hover;
    }
  }
}

.icon-group {
  height: 100%;

  svg {
    margin-right: 0.8rem;

    &:last-child {
      margin-right: 0;
    }
  }
}

.navbar-brand {
  width: 10%;
}

.nav-brand-img {
  width: 90%;
}

.search-container {
  position: relative;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6.3333333333vw;

  .__input-wrapper {
    input {
      position: absolute;
      top: 0;
      right: 0;
      width: 0vw;
      height: 100%;
      border: none;
      border-radius: 0;
      transition: all 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
      pointer-events: none;
      padding: 0;
    }
  }

  .__cta-search {
    color: white;
    position: relative;
    z-index: 2;
    cursor: pointer;
  }

  &.active {
    .__input-wrapper {
      input {
        width: 39.666666665vw;
        pointer-events: auto;
        padding: 20px 40px;
        font-size: 2.1rem;
      }
    }

    .__cta-search {
      color: black;
      cursor: pointer;
    }
  }
}

.search-results {
  background-color: $grey-b2b;
  padding-top: 8rem;
  padding-bottom: 8rem;
  max-height: calc(100vh - 100px);
  overflow: auto;

  &__item {
    margin-bottom: 3rem;

    em {
      font-size: 2.1rem;
      font-style: normal;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>